import Button from "components/base/Button";
import { Input, Select } from "components/base/Form";
import { useState } from "react";
import { v4 } from "uuid";
import { PACKAGING_TYPES } from "../consts";

const PackagingOptionForm = ({
  components,
  initialValues,
  onSave,
  onDelete,
}) => {
  const [packagingInfo, setPackingInfo] = useState(
    initialValues
      ? {
          ...initialValues,
          components: components.map((i) => {
            const matchedComponent = initialValues.components.find(
              (c) => c.id === i.id,
            );
            return {
              id: i.id,
              name: i.name,
              qty: matchedComponent ? matchedComponent.qty : i.qty,
              type: i.type || "Product",
              selected: matchedComponent ? matchedComponent.selected : true,
            };
          }),
        }
      : {
          id: v4(),
          packagingType: PACKAGING_TYPES[0],
          bomQty: 1,
          orderQty: 3000,
          components: components.map((i) => ({
            id: i.id,
            name: i.name,
            qty: i.qty,
            type: i.type || "Product",
            selected: true,
          })),
        },
  );

  function saveHandler() {
    onSave(packagingInfo);
  }

  function deleteHandler() {
    if (window.confirm("Are you sure you want to delete this packaging?")) {
      onDelete(packagingInfo.id);
    }
  }

  return (
    <div className="text-sm">
      <div className="-mx-2">
        <table>
          <tbody>
            <tr>
              <td>
                <label>Packaging Type: </label>
              </td>
              <td className="w-full">
                <Select
                  value={packagingInfo.packagingType}
                  onChange={(e) =>
                    setPackingInfo({
                      ...packagingInfo,
                      packagingType: e.target.value,
                    })
                  }
                >
                  {PACKAGING_TYPES.map((type) => (
                    <option key={type} value={type}>
                      {type}
                    </option>
                  ))}
                </Select>
              </td>
            </tr>
            <tr>
              <td>
                <label>Qty / Outer Carton: </label>
              </td>
              <td className="w-full">
                <Input
                  className="text-center"
                  type="number"
                  value={packagingInfo.bomQty}
                  onChange={(e) =>
                    setPackingInfo({
                      ...packagingInfo,
                      bomQty: e.target.value,
                    })
                  }
                />
              </td>
            </tr>
            <tr>
              <td className=" align-baseline">
                <label>Estimate Order Qty: </label>
              </td>
              <td className="w-full align-baseline">
                <div className="flex space-x-2 items-center">
                  <Input
                    className="text-center"
                    type="number"
                    value={packagingInfo.orderQty}
                    onChange={(e) =>
                      setPackingInfo({
                        ...packagingInfo,
                        orderQty: e.target.value,
                      })
                    }
                  />
                </div>

                {!Number.isInteger(
                  packagingInfo.orderQty / packagingInfo.bomQty,
                ) && (
                  <div className="text-red-600 font-semibold text-xs mt-1">
                    The order quantity is not a multiple of the qty/ctn. Round
                    up to the nearest multiple --{" "}
                    {Math.ceil(packagingInfo.orderQty / packagingInfo.bomQty) *
                      packagingInfo.bomQty}
                    . Wis uses this quantity to calculate the cost per unit.
                  </div>
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <hr />

      <div>
        <h5>Components for this packaging</h5>
        <div className="-mx-2 mt-4">
          <table>
            <tbody>
              {packagingInfo.components.map((i, index) => (
                <tr
                  key={index}
                  className={`border-y
                    ${i.selected ? "" : "opacity-50"}
                  `}
                >
                  <td>
                    <div className="flex flex-col items-center">
                      <input
                        type="checkbox"
                        checked={i.selected}
                        onChange={(e) => {
                          const newComponents = [...packagingInfo.components];
                          newComponents[index].selected = e.target.checked;
                          setPackingInfo({
                            ...packagingInfo,
                            components: newComponents,
                          });
                        }}
                      />
                    </div>
                  </td>
                  <td className="w-full">
                    {i.type === "Product" ? "⚽️" : "📦"} {i.name}
                  </td>
                  <td>
                    <Input
                      className="text-center"
                      value={i.qty}
                      onChange={(e) => {
                        const newComponents = [...packagingInfo.components];
                        newComponents[index].qty = e.target.value;
                        setPackingInfo({
                          ...packagingInfo,
                          components: newComponents,
                        });
                      }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="mt-6 text-sm flex justify-between items-center">
        <Button primary onClick={saveHandler}>
          Save Packaging
        </Button>

        <Button danger onClick={deleteHandler}>
          Delete Packaging
        </Button>
      </div>
    </div>
  );
};

export default PackagingOptionForm;
